import React, { createContext, useContext, useEffect, useState } from "react";

const WishlistContext = createContext(null);
const KEY = "noir_wishlist_v1";
const RECENT_KEY = "noir_recent_v1";

export function WishlistProvider({ children }) {
  const [ids, setIds] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); }
    catch (err) { console.warn("wishlist read failed", err); return []; }
  });

  useEffect(() => {
    try { localStorage.setItem(KEY, JSON.stringify(ids)); }
    catch (err) { console.warn("wishlist write failed", err); }
  }, [ids]);

  const toggle = (id) => setIds((prev) => prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]);
  const has = (id) => ids.includes(id);

  return <WishlistContext.Provider value={{ ids, toggle, has }}>{children}</WishlistContext.Provider>;
}

export const useWishlist = () => {
  const ctx = useContext(WishlistContext);
  if (!ctx) throw new Error("useWishlist must be used within WishlistProvider");
  return ctx;
};

// Recently viewed helpers (module-scope, stable references)
export const addRecent = (id) => {
  try {
    const arr = JSON.parse(localStorage.getItem(RECENT_KEY) || "[]").filter((x) => x !== id);
    arr.unshift(id);
    localStorage.setItem(RECENT_KEY, JSON.stringify(arr.slice(0, 8)));
  } catch (err) {
    console.warn("recent write failed", err);
  }
};

export const getRecent = () => {
  try { return JSON.parse(localStorage.getItem(RECENT_KEY) || "[]"); }
  catch (err) { console.warn("recent read failed", err); return []; }
};
